var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombiBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_371",
    x: 0,
    y: 0.1,
    width: 41.9,
    height: 42,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#Pfad_371)",
    transform: "translate(3, 3)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2848",
    d: "m29.994 4.6-1.41 1.409a16 16 0 1 1-21.29.115L5.89 4.7a18 18 0 1 0 24.1-.106",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    "data-name": "Pfad 2847",
    d: "M16.328 11.724h3.32v4.2l-3.32 2.176zM8.9 3.468h18.165l-7.158 7.157h-3.919zM8.488 1h19v1.468h-19zm-.973-1v3.487l7.813 7.893v8.573l5.32-3.491V11.3l7.831-7.831h.006V0z",
    style: {
      fill: "#f5f5f5"
    }
  }), " -->\n        ", /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    "data-name": "Rechteck 2552",
    transform: "translate(5.104 13.208)",
    style: {
      fill: "#f5f5f5"
    },
    d: "M0 0h2.972v5.945H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    "data-name": "Rechteck 2553",
    transform: "translate(10.306 13.208)",
    style: {
      fill: "#f5f5f5"
    },
    d: "M0 0h2.972v5.945H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    "data-name": "Rechteck 2554",
    transform: "translate(22.705 13.208)",
    style: {
      fill: "#f5f5f5"
    },
    d: "M0 0h2.972v5.945H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    "data-name": "Rechteck 2555",
    transform: "translate(27.528 13.208)",
    style: {
      fill: "#f5f5f5"
    },
    d: "M0 0h2.972v5.945H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    "data-name": "Pfad 2849",
    d: "M18 31.822a5.571 5.571 0 0 0 4.054-1.751l-.712-.711a4.593 4.593 0 1 1-.189-6.455l.711-.711A5.59 5.59 0 1 0 18 31.822",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    "data-name": "Pfad 2850",
    d: "M18 22.57a3.658 3.658 0 1 0 3.658 3.659A3.662 3.662 0 0 0 18 22.57m0 6.317a2.656 2.656 0 0 1-2.2-4.149l1.845 1.844a.5.5 0 0 0 .707 0 .5.5 0 0 0 0-.707l-1.845-1.844A2.635 2.635 0 0 1 18 23.57a2.658 2.658 0 0 1 0 5.317",
    style: {
      fill: "#f5f5f5"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCombiBox);
export default __webpack_public_path__ + "static/media/combi-box.56a8620d5aab7f8123a38c7714b7b908.svg";
export { ForwardRef as ReactComponent };